const getReportsState = (state) => state && state.report ? state.report : {};
export const selectedOption = (state) => getReportsState(state).selectedOption;

export const eventList = (state) => getReportsState(state).eventList;
export const eventListFilter = (state) => getReportsState(state).eventListFilter;
export const errorMessage = (state) => getReportsState(state).errorMessage;
export const isLoading = (state) => getReportsState(state).isLoading;

export const invoice = (state) => getReportsState(state).invoice;